import * as Mod1 from "./discourse/adapters/chat-message";
import * as Mod2 from "./discourse/admin-chat-route-map";
import * as Mod3 from "./discourse/chat-route-map";
import * as Mod4 from "./discourse/components/browse-channels";
import * as Mod5 from "./discourse/components/channel-icon/index";
import * as Mod6 from "./discourse/components/channel-name/index";
import * as Mod7 from "./discourse/components/channel-title/index";
import * as Mod8 from "./discourse/components/channels-list-direct";
import * as Mod9 from "./discourse/components/channels-list-public";
import * as Mod10 from "./discourse/components/channels-list-starred";
import * as Mod11 from "./discourse/components/channels-list";
import * as Mod12 from "./discourse/components/chat-channel-archive-status";
import * as Mod13 from "./discourse/components/chat-channel-card";
import * as Mod14 from "./discourse/components/chat-channel-chooser-header";
import * as Mod15 from "./discourse/components/chat-channel-chooser-row";
import * as Mod16 from "./discourse/components/chat-channel-chooser";
import * as Mod17 from "./discourse/components/chat-channel-filter";
import * as Mod18 from "./discourse/components/chat-channel-leave-btn";
import * as Mod19 from "./discourse/components/chat-channel-list-filter-menu";
import * as Mod20 from "./discourse/components/chat-channel-list-filter-toggle";
import * as Mod21 from "./discourse/components/chat-channel-list-options-button";
import * as Mod22 from "./discourse/components/chat-channel-list-sidebar-menu";
import * as Mod23 from "./discourse/components/chat-channel-list-sort-choice";
import * as Mod24 from "./discourse/components/chat-channel-list-sort-menu";
import * as Mod25 from "./discourse/components/chat-channel-metadata";
import * as Mod26 from "./discourse/components/chat-channel-preview-card";
import * as Mod27 from "./discourse/components/chat-channel-row";
import * as Mod28 from "./discourse/components/chat-channel-sidebar-context-menu";
import * as Mod29 from "./discourse/components/chat-channel-sidebar-context-notification-submenu";
import * as Mod30 from "./discourse/components/chat-channel-status";
import * as Mod31 from "./discourse/components/chat-channel-title";
import * as Mod32 from "./discourse/components/chat-channel-unread-indicator";
import * as Mod33 from "./discourse/components/chat-channel";
import * as Mod34 from "./discourse/components/chat-composer-dropdown";
import * as Mod35 from "./discourse/components/chat-composer-message-details";
import * as Mod36 from "./discourse/components/chat-composer-upload";
import * as Mod37 from "./discourse/components/chat-composer-uploads";
import * as Mod38 from "./discourse/components/chat-composer";
import * as Mod39 from "./discourse/components/chat-drawer";
import * as Mod40 from "./discourse/components/chat-emoji-avatar";
import * as Mod41 from "./discourse/components/chat-footer";
import * as Mod42 from "./discourse/components/chat-header";
import * as Mod43 from "./discourse/components/chat-mention-warnings";
import * as Mod44 from "./discourse/components/chat-message-actions-desktop";
import * as Mod45 from "./discourse/components/chat-message-actions-mobile";
import * as Mod46 from "./discourse/components/chat-message-collapser";
import * as Mod47 from "./discourse/components/chat-message-in-reply-to-indicator";
import * as Mod48 from "./discourse/components/chat-message-reaction";
import * as Mod49 from "./discourse/components/chat-message-reactions-users";
import * as Mod50 from "./discourse/components/chat-message-separator";
import * as Mod51 from "./discourse/components/chat-message-text";
import * as Mod52 from "./discourse/components/chat-message-thread-indicator";
import * as Mod53 from "./discourse/components/chat-message";
import * as Mod54 from "./discourse/components/chat-message/blocks/actions";
import * as Mod55 from "./discourse/components/chat-message/blocks/block";
import * as Mod56 from "./discourse/components/chat-message/blocks/element";
import * as Mod57 from "./discourse/components/chat-message/blocks/elements/button";
import * as Mod58 from "./discourse/components/chat-message/blocks/elements/category";
import * as Mod59 from "./discourse/components/chat-message/blocks/index";
import * as Mod60 from "./discourse/components/chat-message/blocks/informative";
import * as Mod61 from "./discourse/components/chat-messages-container";
import * as Mod62 from "./discourse/components/chat-messages-scroller";
import * as Mod63 from "./discourse/components/chat-notice";
import * as Mod64 from "./discourse/components/chat-notices";
import * as Mod65 from "./discourse/components/chat-pinned-messages-list";
import * as Mod66 from "./discourse/components/chat-replying-indicator";
import * as Mod67 from "./discourse/components/chat-retention-reminder-text";
import * as Mod68 from "./discourse/components/chat-retention-reminder";
import * as Mod69 from "./discourse/components/chat-search";
import * as Mod70 from "./discourse/components/chat-side-panel-resizer";
import * as Mod71 from "./discourse/components/chat-side-panel";
import * as Mod72 from "./discourse/components/chat-sidebar-channel-list-filter-empty-state";
import * as Mod73 from "./discourse/components/chat-sidebar-indicators";
import * as Mod74 from "./discourse/components/chat-skeleton";
import * as Mod75 from "./discourse/components/chat-thread-heading";
import * as Mod76 from "./discourse/components/chat-thread-list";
import * as Mod77 from "./discourse/components/chat-thread-participants";
import * as Mod78 from "./discourse/components/chat-thread-title-prompt";
import * as Mod79 from "./discourse/components/chat-thread";
import * as Mod80 from "./discourse/components/chat-to-topic-selector";
import * as Mod81 from "./discourse/components/chat-upload-drop-zone";
import * as Mod82 from "./discourse/components/chat-upload";
import * as Mod83 from "./discourse/components/chat-user-avatar";
import * as Mod84 from "./discourse/components/chat-user-display-name";
import * as Mod85 from "./discourse/components/chat-user-info";
import * as Mod86 from "./discourse/components/chat/channel/empty-state";
import * as Mod87 from "./discourse/components/chat/composer/button";
import * as Mod88 from "./discourse/components/chat/composer/channel";
import * as Mod89 from "./discourse/components/chat/composer/separator";
import * as Mod90 from "./discourse/components/chat/composer/thread";
import * as Mod91 from "./discourse/components/chat/direct-message-button";
import * as Mod92 from "./discourse/components/chat/disabled";
import * as Mod93 from "./discourse/components/chat/drawer-routes/browse";
import * as Mod94 from "./discourse/components/chat/drawer-routes/channel-info-members";
import * as Mod95 from "./discourse/components/chat/drawer-routes/channel-info-settings";
import * as Mod96 from "./discourse/components/chat/drawer-routes/channel-pins";
import * as Mod97 from "./discourse/components/chat/drawer-routes/channel-thread";
import * as Mod98 from "./discourse/components/chat/drawer-routes/channel-threads";
import * as Mod99 from "./discourse/components/chat/drawer-routes/channel";
import * as Mod100 from "./discourse/components/chat/drawer-routes/channels";
import * as Mod101 from "./discourse/components/chat/drawer-routes/direct-messages";
import * as Mod102 from "./discourse/components/chat/drawer-routes/search";
import * as Mod103 from "./discourse/components/chat/drawer-routes/starred-channels";
import * as Mod104 from "./discourse/components/chat/drawer-routes/threads";
import * as Mod105 from "./discourse/components/chat/footer/unread-indicator";
import * as Mod106 from "./discourse/components/chat/form";
import * as Mod107 from "./discourse/components/chat/form/row";
import * as Mod108 from "./discourse/components/chat/form/section";
import * as Mod109 from "./discourse/components/chat/header/icon";
import * as Mod110 from "./discourse/components/chat/header/icon/unread-indicator";
import * as Mod111 from "./discourse/components/chat/list/empty-state";
import * as Mod112 from "./discourse/components/chat/list/index";
import * as Mod113 from "./discourse/components/chat/list/item";
import * as Mod114 from "./discourse/components/chat/message-creator/add-members";
import * as Mod115 from "./discourse/components/chat/message-creator/channel";
import * as Mod116 from "./discourse/components/chat/message-creator/constants";
import * as Mod117 from "./discourse/components/chat/message-creator/group";
import * as Mod118 from "./discourse/components/chat/message-creator/index";
import * as Mod119 from "./discourse/components/chat/message-creator/lib/chatables-loader";
import * as Mod120 from "./discourse/components/chat/message-creator/lib/iterate-list";
import * as Mod121 from "./discourse/components/chat/message-creator/list-action";
import * as Mod122 from "./discourse/components/chat/message-creator/list-handler";
import * as Mod123 from "./discourse/components/chat/message-creator/list";
import * as Mod124 from "./discourse/components/chat/message-creator/member";
import * as Mod125 from "./discourse/components/chat/message-creator/members-count";
import * as Mod126 from "./discourse/components/chat/message-creator/members-selector";
import * as Mod127 from "./discourse/components/chat/message-creator/members";
import * as Mod128 from "./discourse/components/chat/message-creator/new-group";
import * as Mod129 from "./discourse/components/chat/message-creator/search-input";
import * as Mod130 from "./discourse/components/chat/message-creator/search";
import * as Mod131 from "./discourse/components/chat/message-creator/user";
import * as Mod132 from "./discourse/components/chat/message/avatar";
import * as Mod133 from "./discourse/components/chat/message/error";
import * as Mod134 from "./discourse/components/chat/message/info";
import * as Mod135 from "./discourse/components/chat/message/left-gutter";
import * as Mod136 from "./discourse/components/chat/modal/archive-channel";
import * as Mod137 from "./discourse/components/chat/modal/create-channel";
import * as Mod138 from "./discourse/components/chat/modal/delete-channel";
import * as Mod139 from "./discourse/components/chat/modal/delete-messages-confirm";
import * as Mod140 from "./discourse/components/chat/modal/edit-channel-description";
import * as Mod141 from "./discourse/components/chat/modal/edit-channel-name";
import * as Mod142 from "./discourse/components/chat/modal/move-message-to-channel";
import * as Mod143 from "./discourse/components/chat/modal/new-message";
import * as Mod144 from "./discourse/components/chat/modal/thread-settings";
import * as Mod145 from "./discourse/components/chat/modal/toggle-channel-status";
import * as Mod146 from "./discourse/components/chat/navbar/actions";
import * as Mod147 from "./discourse/components/chat/navbar/back-button";
import * as Mod148 from "./discourse/components/chat/navbar/channel-list-options-button";
import * as Mod149 from "./discourse/components/chat/navbar/channel-title";
import * as Mod150 from "./discourse/components/chat/navbar/close-drawer-button";
import * as Mod151 from "./discourse/components/chat/navbar/close-pins-button";
import * as Mod152 from "./discourse/components/chat/navbar/close-thread-button";
import * as Mod153 from "./discourse/components/chat/navbar/close-threads-button";
import * as Mod154 from "./discourse/components/chat/navbar/filter";
import * as Mod155 from "./discourse/components/chat/navbar/full-page-button";
import * as Mod156 from "./discourse/components/chat/navbar/index";
import * as Mod157 from "./discourse/components/chat/navbar/new-channel-button";
import * as Mod158 from "./discourse/components/chat/navbar/open-drawer-button";
import * as Mod159 from "./discourse/components/chat/navbar/pinned-messages-button";
import * as Mod160 from "./discourse/components/chat/navbar/sub-title";
import * as Mod161 from "./discourse/components/chat/navbar/thread-settings-button";
import * as Mod162 from "./discourse/components/chat/navbar/thread-tracking-dropdown";
import * as Mod163 from "./discourse/components/chat/navbar/threads-list-button";
import * as Mod164 from "./discourse/components/chat/navbar/title";
import * as Mod165 from "./discourse/components/chat/navbar/toggle-drawer-button";
import * as Mod166 from "./discourse/components/chat/notices/mention_without_membership";
import * as Mod167 from "./discourse/components/chat/pinned-message-bar";
import * as Mod168 from "./discourse/components/chat/pinned-messages-list/header";
import * as Mod169 from "./discourse/components/chat/routes/channel-info-members";
import * as Mod170 from "./discourse/components/chat/routes/channel-info-nav";
import * as Mod171 from "./discourse/components/chat/routes/channel-info-settings";
import * as Mod172 from "./discourse/components/chat/routes/channel-info";
import * as Mod173 from "./discourse/components/chat/routes/channel-pins";
import * as Mod174 from "./discourse/components/chat/routes/channel-thread";
import * as Mod175 from "./discourse/components/chat/routes/channel-threads";
import * as Mod176 from "./discourse/components/chat/routes/channel";
import * as Mod177 from "./discourse/components/chat/routes/channels";
import * as Mod178 from "./discourse/components/chat/routes/direct-messages";
import * as Mod179 from "./discourse/components/chat/routes/search";
import * as Mod180 from "./discourse/components/chat/routes/starred-channels";
import * as Mod181 from "./discourse/components/chat/routes/threads";
import * as Mod182 from "./discourse/components/chat/scroll-to-bottom-arrow";
import * as Mod183 from "./discourse/components/chat/selection-manager";
import * as Mod184 from "./discourse/components/chat/thread-list/header";
import * as Mod185 from "./discourse/components/chat/thread-list/item";
import * as Mod186 from "./discourse/components/chat/thread/header-unread-indicator";
import * as Mod187 from "./discourse/components/chat/thread/header";
import * as Mod188 from "./discourse/components/collapser";
import * as Mod189 from "./discourse/components/full-page-chat";
import * as Mod190 from "./discourse/components/reviewable/chat-message";
import * as Mod191 from "./discourse/components/styleguide/chat-composer-message-details";
import * as Mod192 from "./discourse/components/styleguide/chat-composer";
import * as Mod193 from "./discourse/components/styleguide/chat-header-icon";
import * as Mod194 from "./discourse/components/styleguide/chat-message";
import * as Mod195 from "./discourse/components/styleguide/chat-modal-archive-channel";
import * as Mod196 from "./discourse/components/styleguide/chat-modal-create-channel";
import * as Mod197 from "./discourse/components/styleguide/chat-modal-delete-channel";
import * as Mod198 from "./discourse/components/styleguide/chat-modal-edit-channel-description";
import * as Mod199 from "./discourse/components/styleguide/chat-modal-edit-channel-name";
import * as Mod200 from "./discourse/components/styleguide/chat-modal-move-message-to-channel";
import * as Mod201 from "./discourse/components/styleguide/chat-modal-new-message";
import * as Mod202 from "./discourse/components/styleguide/chat-modal-thread-settings";
import * as Mod203 from "./discourse/components/styleguide/chat-modal-toggle-channel-status";
import * as Mod204 from "./discourse/components/styleguide/chat-thread-list-item";
import * as Mod205 from "./discourse/components/styleguide/organisms/chat";
import * as Mod206 from "./discourse/components/svg/chat-zero";
import * as Mod207 from "./discourse/components/thread-notifications-tracking";
import * as Mod208 from "./discourse/components/thread-title/index";
import * as Mod209 from "./discourse/components/thread-unread-indicator/index";
import * as Mod210 from "./discourse/components/toggle-channel-membership-button";
import * as Mod211 from "./discourse/components/upsert-category/chat";
import * as Mod212 from "./discourse/components/user-menu/chat-notifications-list-empty-state";
import * as Mod213 from "./discourse/components/user-menu/chat-notifications-list";
import * as Mod214 from "./discourse/components/user-threads/index";
import * as Mod215 from "./discourse/components/user-threads/preview";
import * as Mod216 from "./discourse/connectors/above-site-header/chat-body-class.gjs";
import * as Mod217 from "./discourse/connectors/below-footer/chat-drawer-outlet.gjs";
import * as Mod218 from "./discourse/connectors/chat-composer-inline-buttons/emoji-picker.gjs";
import * as Mod219 from "./discourse/connectors/home-logo-wrapper/chat-header-connector.gjs";
import * as Mod220 from "./discourse/connectors/user-card-below-message-button/chat-button.gjs";
import * as Mod221 from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails.gjs";
import * as Mod222 from "./discourse/connectors/user-preferences-nav/chat-preferences.gjs";
import * as Mod223 from "./discourse/connectors/user-preferences-notifications/chat-notifications.gjs";
import * as Mod224 from "./discourse/connectors/user-profile-controls/chat-button.gjs";
import * as Mod225 from "./discourse/controllers/chat-draft-channel";
import * as Mod226 from "./discourse/controllers/chat";
import * as Mod227 from "./discourse/controllers/chat/channel";
import * as Mod228 from "./discourse/controllers/chat/channel/index";
import * as Mod229 from "./discourse/controllers/chat/channel/thread";
import * as Mod230 from "./discourse/controllers/chat/index";
import * as Mod231 from "./discourse/controllers/chat/new-message";
import * as Mod232 from "./discourse/helpers/chat-guardian";
import * as Mod233 from "./discourse/helpers/first-visible-message-id";
import * as Mod234 from "./discourse/helpers/format-chat-date";
import * as Mod235 from "./discourse/initializers/chat-audio";
import * as Mod236 from "./discourse/initializers/chat-category-tab";
import * as Mod237 from "./discourse/initializers/chat-decorators";
import * as Mod238 from "./discourse/initializers/chat-keyboard-shortcuts";
import * as Mod239 from "./discourse/initializers/chat-plugin-decorators";
import * as Mod240 from "./discourse/initializers/chat-setup";
import * as Mod241 from "./discourse/initializers/chat-sidebar";
import * as Mod242 from "./discourse/initializers/chat-user-menu";
import * as Mod243 from "./discourse/initializers/chat-user-options";
import * as Mod244 from "./discourse/lib/chat-alert-dedup";
import * as Mod245 from "./discourse/lib/chat-channel-list-options";
import * as Mod246 from "./discourse/lib/chat-channel-subscription-manager";
import * as Mod247 from "./discourse/lib/chat-channel-thread-subscription-manager";
import * as Mod248 from "./discourse/lib/chat-composer-buttons";
import * as Mod249 from "./discourse/lib/chat-constants";
import * as Mod250 from "./discourse/lib/chat-message-announcement";
import * as Mod251 from "./discourse/lib/chat-message-container";
import * as Mod252 from "./discourse/lib/chat-message-flag";
import * as Mod253 from "./discourse/lib/chat-message-interactor";
import * as Mod254 from "./discourse/lib/chat-messages-loader";
import * as Mod255 from "./discourse/lib/chat-messages-manager";
import * as Mod256 from "./discourse/lib/chat-notification-levels";
import * as Mod257 from "./discourse/lib/chat-pane-state";
import * as Mod258 from "./discourse/lib/chat-pinned-bar-dismissal";
import * as Mod259 from "./discourse/lib/chat-threads-manager";
import * as Mod260 from "./discourse/lib/chat-user-preferences";
import * as Mod261 from "./discourse/lib/check-message-visibility";
import * as Mod262 from "./discourse/lib/collection";
import * as Mod263 from "./discourse/lib/dates-separators-positioner";
import * as Mod264 from "./discourse/lib/extract-current-topic-info";
import * as Mod265 from "./discourse/lib/fabricators";
import * as Mod266 from "./discourse/lib/get-reaction-text";
import * as Mod267 from "./discourse/lib/get-user-chat-separate-sidebar-mode";
import * as Mod268 from "./discourse/lib/gif-pick-handler";
import * as Mod269 from "./discourse/lib/hashtag-types/channel";
import * as Mod270 from "./discourse/lib/init-sidebar-state";
import * as Mod271 from "./discourse/lib/scroll-helpers";
import * as Mod272 from "./discourse/lib/slugify-channel";
import * as Mod273 from "./discourse/lib/textarea-interactor";
import * as Mod274 from "./discourse/lib/transform-auto-links";
import * as Mod275 from "./discourse/models/chat-channel-archive";
import * as Mod276 from "./discourse/models/chat-channel";
import * as Mod277 from "./discourse/models/chat-chatable";
import * as Mod278 from "./discourse/models/chat-direct-message";
import * as Mod279 from "./discourse/models/chat-message-reaction";
import * as Mod280 from "./discourse/models/chat-message";
import * as Mod281 from "./discourse/models/chat-notice";
import * as Mod282 from "./discourse/models/chat-thread-preview";
import * as Mod283 from "./discourse/models/chat-thread";
import * as Mod284 from "./discourse/models/chat-tracking-state";
import * as Mod285 from "./discourse/models/user-chat-channel-membership";
import * as Mod286 from "./discourse/models/user-chat-thread-membership";
import * as Mod287 from "./discourse/modifiers/chat/later-fn";
import * as Mod288 from "./discourse/modifiers/chat/on-animation-end";
import * as Mod289 from "./discourse/modifiers/chat/on-long-press";
import * as Mod290 from "./discourse/modifiers/chat/on-scroll";
import * as Mod291 from "./discourse/modifiers/chat/resizable-node";
import * as Mod292 from "./discourse/modifiers/chat/scrollable-list";
import * as Mod293 from "./discourse/modifiers/chat/track-message-separator-date";
import * as Mod294 from "./discourse/modifiers/chat/track-message";
import * as Mod295 from "./discourse/pre-initializers/chat-plugin-api";
import * as Mod296 from "./discourse/preferences-chat-route-map";
import * as Mod297 from "./discourse/routes/chat-channel-decorator";
import * as Mod298 from "./discourse/routes/chat-channel-legacy";
import * as Mod299 from "./discourse/routes/chat-draft-channel";
import * as Mod300 from "./discourse/routes/chat";
import * as Mod301 from "./discourse/routes/chat/browse";
import * as Mod302 from "./discourse/routes/chat/browse/archived";
import * as Mod303 from "./discourse/routes/chat/browse/index";
import * as Mod304 from "./discourse/routes/chat/channel";
import * as Mod305 from "./discourse/routes/chat/channel/info";
import * as Mod306 from "./discourse/routes/chat/channel/info/index";
import * as Mod307 from "./discourse/routes/chat/channel/info/members";
import * as Mod308 from "./discourse/routes/chat/channel/info/search";
import * as Mod309 from "./discourse/routes/chat/channel/near-message-with-thread";
import * as Mod310 from "./discourse/routes/chat/channel/near-message";
import * as Mod311 from "./discourse/routes/chat/channel/pins";
import * as Mod312 from "./discourse/routes/chat/channel/thread";
import * as Mod313 from "./discourse/routes/chat/channel/thread/near-message";
import * as Mod314 from "./discourse/routes/chat/channel/threads";
import * as Mod315 from "./discourse/routes/chat/channels";
import * as Mod316 from "./discourse/routes/chat/direct-messages";
import * as Mod317 from "./discourse/routes/chat/disabled";
import * as Mod318 from "./discourse/routes/chat/index";
import * as Mod319 from "./discourse/routes/chat/new-message";
import * as Mod320 from "./discourse/routes/chat/search";
import * as Mod321 from "./discourse/routes/chat/starred-channels";
import * as Mod322 from "./discourse/routes/chat/threads";
import * as Mod323 from "./discourse/routes/preferences/chat";
import * as Mod324 from "./discourse/services/chat-admin-api";
import * as Mod325 from "./discourse/services/chat-api";
import * as Mod326 from "./discourse/services/chat-audio-manager";
import * as Mod327 from "./discourse/services/chat-channel-composer";
import * as Mod328 from "./discourse/services/chat-channel-info-route-origin-manager";
import * as Mod329 from "./discourse/services/chat-channel-list-preferences";
import * as Mod330 from "./discourse/services/chat-channel-notices-manager";
import * as Mod331 from "./discourse/services/chat-channel-pane";
import * as Mod332 from "./discourse/services/chat-channel-scroll-positions";
import * as Mod333 from "./discourse/services/chat-channels-manager";
import * as Mod334 from "./discourse/services/chat-composer-warnings-tracker";
import * as Mod335 from "./discourse/services/chat-drafts-manager";
import * as Mod336 from "./discourse/services/chat-drawer-router";
import * as Mod337 from "./discourse/services/chat-drawer-size";
import * as Mod338 from "./discourse/services/chat-guardian";
import * as Mod339 from "./discourse/services/chat-history";
import * as Mod340 from "./discourse/services/chat-new-message-announcer";
import * as Mod341 from "./discourse/services/chat-notification-manager";
import * as Mod342 from "./discourse/services/chat-pane-pending-manager";
import * as Mod343 from "./discourse/services/chat-search-query";
import * as Mod344 from "./discourse/services/chat-state-manager";
import * as Mod345 from "./discourse/services/chat-subscriptions-manager";
import * as Mod346 from "./discourse/services/chat-thread-composer";
import * as Mod347 from "./discourse/services/chat-thread-list-pane";
import * as Mod348 from "./discourse/services/chat-thread-pane";
import * as Mod349 from "./discourse/services/chat-tracking-state-manager";
import * as Mod350 from "./discourse/services/chat";
import * as Mod351 from "./discourse/services/interacted-chat-message";
import * as Mod352 from "./discourse/templates/chat";
import * as Mod353 from "./discourse/templates/chat/browse";
import * as Mod354 from "./discourse/templates/chat/browse/all";
import * as Mod355 from "./discourse/templates/chat/browse/archived";
import * as Mod356 from "./discourse/templates/chat/browse/closed";
import * as Mod357 from "./discourse/templates/chat/browse/open";
import * as Mod358 from "./discourse/templates/chat/channel";
import * as Mod359 from "./discourse/templates/chat/channel/info";
import * as Mod360 from "./discourse/templates/chat/channel/info/members";
import * as Mod361 from "./discourse/templates/chat/channel/info/settings";
import * as Mod362 from "./discourse/templates/chat/channel/pins";
import * as Mod363 from "./discourse/templates/chat/channel/thread";
import * as Mod364 from "./discourse/templates/chat/channel/threads";
import * as Mod365 from "./discourse/templates/chat/channels";
import * as Mod366 from "./discourse/templates/chat/direct-messages";
import * as Mod367 from "./discourse/templates/chat/disabled";
import * as Mod368 from "./discourse/templates/chat/index";
import * as Mod369 from "./discourse/templates/chat/search";
import * as Mod370 from "./discourse/templates/chat/starred-channels";
import * as Mod371 from "./discourse/templates/chat/threads";
import * as Mod372 from "./discourse/templates/preferences/chat";
import * as Mod373 from "./lib/discourse-markdown/chat-html-inline";
import * as Mod374 from "./lib/discourse-markdown/chat-transcript";
import * as Mod375 from "./lib/rich-editor-extension";
const compatModules = {
  "discourse/adapters/chat-message": Mod1,
  "discourse/admin-chat-route-map": Mod2,
  "discourse/chat-route-map": Mod3,
  "discourse/components/browse-channels": Mod4,
  "discourse/components/channel-icon/index": Mod5,
  "discourse/components/channel-name/index": Mod6,
  "discourse/components/channel-title/index": Mod7,
  "discourse/components/channels-list-direct": Mod8,
  "discourse/components/channels-list-public": Mod9,
  "discourse/components/channels-list-starred": Mod10,
  "discourse/components/channels-list": Mod11,
  "discourse/components/chat-channel-archive-status": Mod12,
  "discourse/components/chat-channel-card": Mod13,
  "discourse/components/chat-channel-chooser-header": Mod14,
  "discourse/components/chat-channel-chooser-row": Mod15,
  "discourse/components/chat-channel-chooser": Mod16,
  "discourse/components/chat-channel-filter": Mod17,
  "discourse/components/chat-channel-leave-btn": Mod18,
  "discourse/components/chat-channel-list-filter-menu": Mod19,
  "discourse/components/chat-channel-list-filter-toggle": Mod20,
  "discourse/components/chat-channel-list-options-button": Mod21,
  "discourse/components/chat-channel-list-sidebar-menu": Mod22,
  "discourse/components/chat-channel-list-sort-choice": Mod23,
  "discourse/components/chat-channel-list-sort-menu": Mod24,
  "discourse/components/chat-channel-metadata": Mod25,
  "discourse/components/chat-channel-preview-card": Mod26,
  "discourse/components/chat-channel-row": Mod27,
  "discourse/components/chat-channel-sidebar-context-menu": Mod28,
  "discourse/components/chat-channel-sidebar-context-notification-submenu": Mod29,
  "discourse/components/chat-channel-status": Mod30,
  "discourse/components/chat-channel-title": Mod31,
  "discourse/components/chat-channel-unread-indicator": Mod32,
  "discourse/components/chat-channel": Mod33,
  "discourse/components/chat-composer-dropdown": Mod34,
  "discourse/components/chat-composer-message-details": Mod35,
  "discourse/components/chat-composer-upload": Mod36,
  "discourse/components/chat-composer-uploads": Mod37,
  "discourse/components/chat-composer": Mod38,
  "discourse/components/chat-drawer": Mod39,
  "discourse/components/chat-emoji-avatar": Mod40,
  "discourse/components/chat-footer": Mod41,
  "discourse/components/chat-header": Mod42,
  "discourse/components/chat-mention-warnings": Mod43,
  "discourse/components/chat-message-actions-desktop": Mod44,
  "discourse/components/chat-message-actions-mobile": Mod45,
  "discourse/components/chat-message-collapser": Mod46,
  "discourse/components/chat-message-in-reply-to-indicator": Mod47,
  "discourse/components/chat-message-reaction": Mod48,
  "discourse/components/chat-message-reactions-users": Mod49,
  "discourse/components/chat-message-separator": Mod50,
  "discourse/components/chat-message-text": Mod51,
  "discourse/components/chat-message-thread-indicator": Mod52,
  "discourse/components/chat-message": Mod53,
  "discourse/components/chat-message/blocks/actions": Mod54,
  "discourse/components/chat-message/blocks/block": Mod55,
  "discourse/components/chat-message/blocks/element": Mod56,
  "discourse/components/chat-message/blocks/elements/button": Mod57,
  "discourse/components/chat-message/blocks/elements/category": Mod58,
  "discourse/components/chat-message/blocks/index": Mod59,
  "discourse/components/chat-message/blocks/informative": Mod60,
  "discourse/components/chat-messages-container": Mod61,
  "discourse/components/chat-messages-scroller": Mod62,
  "discourse/components/chat-notice": Mod63,
  "discourse/components/chat-notices": Mod64,
  "discourse/components/chat-pinned-messages-list": Mod65,
  "discourse/components/chat-replying-indicator": Mod66,
  "discourse/components/chat-retention-reminder-text": Mod67,
  "discourse/components/chat-retention-reminder": Mod68,
  "discourse/components/chat-search": Mod69,
  "discourse/components/chat-side-panel-resizer": Mod70,
  "discourse/components/chat-side-panel": Mod71,
  "discourse/components/chat-sidebar-channel-list-filter-empty-state": Mod72,
  "discourse/components/chat-sidebar-indicators": Mod73,
  "discourse/components/chat-skeleton": Mod74,
  "discourse/components/chat-thread-heading": Mod75,
  "discourse/components/chat-thread-list": Mod76,
  "discourse/components/chat-thread-participants": Mod77,
  "discourse/components/chat-thread-title-prompt": Mod78,
  "discourse/components/chat-thread": Mod79,
  "discourse/components/chat-to-topic-selector": Mod80,
  "discourse/components/chat-upload-drop-zone": Mod81,
  "discourse/components/chat-upload": Mod82,
  "discourse/components/chat-user-avatar": Mod83,
  "discourse/components/chat-user-display-name": Mod84,
  "discourse/components/chat-user-info": Mod85,
  "discourse/components/chat/channel/empty-state": Mod86,
  "discourse/components/chat/composer/button": Mod87,
  "discourse/components/chat/composer/channel": Mod88,
  "discourse/components/chat/composer/separator": Mod89,
  "discourse/components/chat/composer/thread": Mod90,
  "discourse/components/chat/direct-message-button": Mod91,
  "discourse/components/chat/disabled": Mod92,
  "discourse/components/chat/drawer-routes/browse": Mod93,
  "discourse/components/chat/drawer-routes/channel-info-members": Mod94,
  "discourse/components/chat/drawer-routes/channel-info-settings": Mod95,
  "discourse/components/chat/drawer-routes/channel-pins": Mod96,
  "discourse/components/chat/drawer-routes/channel-thread": Mod97,
  "discourse/components/chat/drawer-routes/channel-threads": Mod98,
  "discourse/components/chat/drawer-routes/channel": Mod99,
  "discourse/components/chat/drawer-routes/channels": Mod100,
  "discourse/components/chat/drawer-routes/direct-messages": Mod101,
  "discourse/components/chat/drawer-routes/search": Mod102,
  "discourse/components/chat/drawer-routes/starred-channels": Mod103,
  "discourse/components/chat/drawer-routes/threads": Mod104,
  "discourse/components/chat/footer/unread-indicator": Mod105,
  "discourse/components/chat/form": Mod106,
  "discourse/components/chat/form/row": Mod107,
  "discourse/components/chat/form/section": Mod108,
  "discourse/components/chat/header/icon": Mod109,
  "discourse/components/chat/header/icon/unread-indicator": Mod110,
  "discourse/components/chat/list/empty-state": Mod111,
  "discourse/components/chat/list/index": Mod112,
  "discourse/components/chat/list/item": Mod113,
  "discourse/components/chat/message-creator/add-members": Mod114,
  "discourse/components/chat/message-creator/channel": Mod115,
  "discourse/components/chat/message-creator/constants": Mod116,
  "discourse/components/chat/message-creator/group": Mod117,
  "discourse/components/chat/message-creator/index": Mod118,
  "discourse/components/chat/message-creator/lib/chatables-loader": Mod119,
  "discourse/components/chat/message-creator/lib/iterate-list": Mod120,
  "discourse/components/chat/message-creator/list-action": Mod121,
  "discourse/components/chat/message-creator/list-handler": Mod122,
  "discourse/components/chat/message-creator/list": Mod123,
  "discourse/components/chat/message-creator/member": Mod124,
  "discourse/components/chat/message-creator/members-count": Mod125,
  "discourse/components/chat/message-creator/members-selector": Mod126,
  "discourse/components/chat/message-creator/members": Mod127,
  "discourse/components/chat/message-creator/new-group": Mod128,
  "discourse/components/chat/message-creator/search-input": Mod129,
  "discourse/components/chat/message-creator/search": Mod130,
  "discourse/components/chat/message-creator/user": Mod131,
  "discourse/components/chat/message/avatar": Mod132,
  "discourse/components/chat/message/error": Mod133,
  "discourse/components/chat/message/info": Mod134,
  "discourse/components/chat/message/left-gutter": Mod135,
  "discourse/components/chat/modal/archive-channel": Mod136,
  "discourse/components/chat/modal/create-channel": Mod137,
  "discourse/components/chat/modal/delete-channel": Mod138,
  "discourse/components/chat/modal/delete-messages-confirm": Mod139,
  "discourse/components/chat/modal/edit-channel-description": Mod140,
  "discourse/components/chat/modal/edit-channel-name": Mod141,
  "discourse/components/chat/modal/move-message-to-channel": Mod142,
  "discourse/components/chat/modal/new-message": Mod143,
  "discourse/components/chat/modal/thread-settings": Mod144,
  "discourse/components/chat/modal/toggle-channel-status": Mod145,
  "discourse/components/chat/navbar/actions": Mod146,
  "discourse/components/chat/navbar/back-button": Mod147,
  "discourse/components/chat/navbar/channel-list-options-button": Mod148,
  "discourse/components/chat/navbar/channel-title": Mod149,
  "discourse/components/chat/navbar/close-drawer-button": Mod150,
  "discourse/components/chat/navbar/close-pins-button": Mod151,
  "discourse/components/chat/navbar/close-thread-button": Mod152,
  "discourse/components/chat/navbar/close-threads-button": Mod153,
  "discourse/components/chat/navbar/filter": Mod154,
  "discourse/components/chat/navbar/full-page-button": Mod155,
  "discourse/components/chat/navbar/index": Mod156,
  "discourse/components/chat/navbar/new-channel-button": Mod157,
  "discourse/components/chat/navbar/open-drawer-button": Mod158,
  "discourse/components/chat/navbar/pinned-messages-button": Mod159,
  "discourse/components/chat/navbar/sub-title": Mod160,
  "discourse/components/chat/navbar/thread-settings-button": Mod161,
  "discourse/components/chat/navbar/thread-tracking-dropdown": Mod162,
  "discourse/components/chat/navbar/threads-list-button": Mod163,
  "discourse/components/chat/navbar/title": Mod164,
  "discourse/components/chat/navbar/toggle-drawer-button": Mod165,
  "discourse/components/chat/notices/mention_without_membership": Mod166,
  "discourse/components/chat/pinned-message-bar": Mod167,
  "discourse/components/chat/pinned-messages-list/header": Mod168,
  "discourse/components/chat/routes/channel-info-members": Mod169,
  "discourse/components/chat/routes/channel-info-nav": Mod170,
  "discourse/components/chat/routes/channel-info-settings": Mod171,
  "discourse/components/chat/routes/channel-info": Mod172,
  "discourse/components/chat/routes/channel-pins": Mod173,
  "discourse/components/chat/routes/channel-thread": Mod174,
  "discourse/components/chat/routes/channel-threads": Mod175,
  "discourse/components/chat/routes/channel": Mod176,
  "discourse/components/chat/routes/channels": Mod177,
  "discourse/components/chat/routes/direct-messages": Mod178,
  "discourse/components/chat/routes/search": Mod179,
  "discourse/components/chat/routes/starred-channels": Mod180,
  "discourse/components/chat/routes/threads": Mod181,
  "discourse/components/chat/scroll-to-bottom-arrow": Mod182,
  "discourse/components/chat/selection-manager": Mod183,
  "discourse/components/chat/thread-list/header": Mod184,
  "discourse/components/chat/thread-list/item": Mod185,
  "discourse/components/chat/thread/header-unread-indicator": Mod186,
  "discourse/components/chat/thread/header": Mod187,
  "discourse/components/collapser": Mod188,
  "discourse/components/full-page-chat": Mod189,
  "discourse/components/reviewable/chat-message": Mod190,
  "discourse/components/styleguide/chat-composer-message-details": Mod191,
  "discourse/components/styleguide/chat-composer": Mod192,
  "discourse/components/styleguide/chat-header-icon": Mod193,
  "discourse/components/styleguide/chat-message": Mod194,
  "discourse/components/styleguide/chat-modal-archive-channel": Mod195,
  "discourse/components/styleguide/chat-modal-create-channel": Mod196,
  "discourse/components/styleguide/chat-modal-delete-channel": Mod197,
  "discourse/components/styleguide/chat-modal-edit-channel-description": Mod198,
  "discourse/components/styleguide/chat-modal-edit-channel-name": Mod199,
  "discourse/components/styleguide/chat-modal-move-message-to-channel": Mod200,
  "discourse/components/styleguide/chat-modal-new-message": Mod201,
  "discourse/components/styleguide/chat-modal-thread-settings": Mod202,
  "discourse/components/styleguide/chat-modal-toggle-channel-status": Mod203,
  "discourse/components/styleguide/chat-thread-list-item": Mod204,
  "discourse/components/styleguide/organisms/chat": Mod205,
  "discourse/components/svg/chat-zero": Mod206,
  "discourse/components/thread-notifications-tracking": Mod207,
  "discourse/components/thread-title/index": Mod208,
  "discourse/components/thread-unread-indicator/index": Mod209,
  "discourse/components/toggle-channel-membership-button": Mod210,
  "discourse/components/upsert-category/chat": Mod211,
  "discourse/components/user-menu/chat-notifications-list-empty-state": Mod212,
  "discourse/components/user-menu/chat-notifications-list": Mod213,
  "discourse/components/user-threads/index": Mod214,
  "discourse/components/user-threads/preview": Mod215,
  "discourse/connectors/above-site-header/chat-body-class": Mod216,
  "discourse/connectors/below-footer/chat-drawer-outlet": Mod217,
  "discourse/connectors/chat-composer-inline-buttons/emoji-picker": Mod218,
  "discourse/connectors/home-logo-wrapper/chat-header-connector": Mod219,
  "discourse/connectors/user-card-below-message-button/chat-button": Mod220,
  "discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails": Mod221,
  "discourse/connectors/user-preferences-nav/chat-preferences": Mod222,
  "discourse/connectors/user-preferences-notifications/chat-notifications": Mod223,
  "discourse/connectors/user-profile-controls/chat-button": Mod224,
  "discourse/controllers/chat-draft-channel": Mod225,
  "discourse/controllers/chat": Mod226,
  "discourse/controllers/chat/channel": Mod227,
  "discourse/controllers/chat/channel/index": Mod228,
  "discourse/controllers/chat/channel/thread": Mod229,
  "discourse/controllers/chat/index": Mod230,
  "discourse/controllers/chat/new-message": Mod231,
  "discourse/helpers/chat-guardian": Mod232,
  "discourse/helpers/first-visible-message-id": Mod233,
  "discourse/helpers/format-chat-date": Mod234,
  "discourse/initializers/chat-audio": Mod235,
  "discourse/initializers/chat-category-tab": Mod236,
  "discourse/initializers/chat-decorators": Mod237,
  "discourse/initializers/chat-keyboard-shortcuts": Mod238,
  "discourse/initializers/chat-plugin-decorators": Mod239,
  "discourse/initializers/chat-setup": Mod240,
  "discourse/initializers/chat-sidebar": Mod241,
  "discourse/initializers/chat-user-menu": Mod242,
  "discourse/initializers/chat-user-options": Mod243,
  "discourse/lib/chat-alert-dedup": Mod244,
  "discourse/lib/chat-channel-list-options": Mod245,
  "discourse/lib/chat-channel-subscription-manager": Mod246,
  "discourse/lib/chat-channel-thread-subscription-manager": Mod247,
  "discourse/lib/chat-composer-buttons": Mod248,
  "discourse/lib/chat-constants": Mod249,
  "discourse/lib/chat-message-announcement": Mod250,
  "discourse/lib/chat-message-container": Mod251,
  "discourse/lib/chat-message-flag": Mod252,
  "discourse/lib/chat-message-interactor": Mod253,
  "discourse/lib/chat-messages-loader": Mod254,
  "discourse/lib/chat-messages-manager": Mod255,
  "discourse/lib/chat-notification-levels": Mod256,
  "discourse/lib/chat-pane-state": Mod257,
  "discourse/lib/chat-pinned-bar-dismissal": Mod258,
  "discourse/lib/chat-threads-manager": Mod259,
  "discourse/lib/chat-user-preferences": Mod260,
  "discourse/lib/check-message-visibility": Mod261,
  "discourse/lib/collection": Mod262,
  "discourse/lib/dates-separators-positioner": Mod263,
  "discourse/lib/extract-current-topic-info": Mod264,
  "discourse/lib/fabricators": Mod265,
  "discourse/lib/get-reaction-text": Mod266,
  "discourse/lib/get-user-chat-separate-sidebar-mode": Mod267,
  "discourse/lib/gif-pick-handler": Mod268,
  "discourse/lib/hashtag-types/channel": Mod269,
  "discourse/lib/init-sidebar-state": Mod270,
  "discourse/lib/scroll-helpers": Mod271,
  "discourse/lib/slugify-channel": Mod272,
  "discourse/lib/textarea-interactor": Mod273,
  "discourse/lib/transform-auto-links": Mod274,
  "discourse/models/chat-channel-archive": Mod275,
  "discourse/models/chat-channel": Mod276,
  "discourse/models/chat-chatable": Mod277,
  "discourse/models/chat-direct-message": Mod278,
  "discourse/models/chat-message-reaction": Mod279,
  "discourse/models/chat-message": Mod280,
  "discourse/models/chat-notice": Mod281,
  "discourse/models/chat-thread-preview": Mod282,
  "discourse/models/chat-thread": Mod283,
  "discourse/models/chat-tracking-state": Mod284,
  "discourse/models/user-chat-channel-membership": Mod285,
  "discourse/models/user-chat-thread-membership": Mod286,
  "discourse/modifiers/chat/later-fn": Mod287,
  "discourse/modifiers/chat/on-animation-end": Mod288,
  "discourse/modifiers/chat/on-long-press": Mod289,
  "discourse/modifiers/chat/on-scroll": Mod290,
  "discourse/modifiers/chat/resizable-node": Mod291,
  "discourse/modifiers/chat/scrollable-list": Mod292,
  "discourse/modifiers/chat/track-message-separator-date": Mod293,
  "discourse/modifiers/chat/track-message": Mod294,
  "discourse/pre-initializers/chat-plugin-api": Mod295,
  "discourse/preferences-chat-route-map": Mod296,
  "discourse/routes/chat-channel-decorator": Mod297,
  "discourse/routes/chat-channel-legacy": Mod298,
  "discourse/routes/chat-draft-channel": Mod299,
  "discourse/routes/chat": Mod300,
  "discourse/routes/chat/browse": Mod301,
  "discourse/routes/chat/browse/archived": Mod302,
  "discourse/routes/chat/browse/index": Mod303,
  "discourse/routes/chat/channel": Mod304,
  "discourse/routes/chat/channel/info": Mod305,
  "discourse/routes/chat/channel/info/index": Mod306,
  "discourse/routes/chat/channel/info/members": Mod307,
  "discourse/routes/chat/channel/info/search": Mod308,
  "discourse/routes/chat/channel/near-message-with-thread": Mod309,
  "discourse/routes/chat/channel/near-message": Mod310,
  "discourse/routes/chat/channel/pins": Mod311,
  "discourse/routes/chat/channel/thread": Mod312,
  "discourse/routes/chat/channel/thread/near-message": Mod313,
  "discourse/routes/chat/channel/threads": Mod314,
  "discourse/routes/chat/channels": Mod315,
  "discourse/routes/chat/direct-messages": Mod316,
  "discourse/routes/chat/disabled": Mod317,
  "discourse/routes/chat/index": Mod318,
  "discourse/routes/chat/new-message": Mod319,
  "discourse/routes/chat/search": Mod320,
  "discourse/routes/chat/starred-channels": Mod321,
  "discourse/routes/chat/threads": Mod322,
  "discourse/routes/preferences/chat": Mod323,
  "discourse/services/chat-admin-api": Mod324,
  "discourse/services/chat-api": Mod325,
  "discourse/services/chat-audio-manager": Mod326,
  "discourse/services/chat-channel-composer": Mod327,
  "discourse/services/chat-channel-info-route-origin-manager": Mod328,
  "discourse/services/chat-channel-list-preferences": Mod329,
  "discourse/services/chat-channel-notices-manager": Mod330,
  "discourse/services/chat-channel-pane": Mod331,
  "discourse/services/chat-channel-scroll-positions": Mod332,
  "discourse/services/chat-channels-manager": Mod333,
  "discourse/services/chat-composer-warnings-tracker": Mod334,
  "discourse/services/chat-drafts-manager": Mod335,
  "discourse/services/chat-drawer-router": Mod336,
  "discourse/services/chat-drawer-size": Mod337,
  "discourse/services/chat-guardian": Mod338,
  "discourse/services/chat-history": Mod339,
  "discourse/services/chat-new-message-announcer": Mod340,
  "discourse/services/chat-notification-manager": Mod341,
  "discourse/services/chat-pane-pending-manager": Mod342,
  "discourse/services/chat-search-query": Mod343,
  "discourse/services/chat-state-manager": Mod344,
  "discourse/services/chat-subscriptions-manager": Mod345,
  "discourse/services/chat-thread-composer": Mod346,
  "discourse/services/chat-thread-list-pane": Mod347,
  "discourse/services/chat-thread-pane": Mod348,
  "discourse/services/chat-tracking-state-manager": Mod349,
  "discourse/services/chat": Mod350,
  "discourse/services/interacted-chat-message": Mod351,
  "discourse/templates/chat": Mod352,
  "discourse/templates/chat/browse": Mod353,
  "discourse/templates/chat/browse/all": Mod354,
  "discourse/templates/chat/browse/archived": Mod355,
  "discourse/templates/chat/browse/closed": Mod356,
  "discourse/templates/chat/browse/open": Mod357,
  "discourse/templates/chat/channel": Mod358,
  "discourse/templates/chat/channel/info": Mod359,
  "discourse/templates/chat/channel/info/members": Mod360,
  "discourse/templates/chat/channel/info/settings": Mod361,
  "discourse/templates/chat/channel/pins": Mod362,
  "discourse/templates/chat/channel/thread": Mod363,
  "discourse/templates/chat/channel/threads": Mod364,
  "discourse/templates/chat/channels": Mod365,
  "discourse/templates/chat/direct-messages": Mod366,
  "discourse/templates/chat/disabled": Mod367,
  "discourse/templates/chat/index": Mod368,
  "discourse/templates/chat/search": Mod369,
  "discourse/templates/chat/starred-channels": Mod370,
  "discourse/templates/chat/threads": Mod371,
  "discourse/templates/preferences/chat": Mod372,
  "lib/discourse-markdown/chat-html-inline": Mod373,
  "lib/discourse-markdown/chat-transcript": Mod374,
  "lib/rich-editor-extension": Mod375,
};
export { compatModules };
export default compatModules;
